import React from 'react';
import { MessageBar, MessageBarType, PrimaryButton, DefaultButton, Stack } from '@fluentui/react';

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
    errorInfo: React.ErrorInfo | null;
    showDetails: boolean;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
            showDetails: false,
        };
    }

    static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
        this.setState({ errorInfo });
    }

    handleReload = () => {
        window.location.reload();
    };

    handleReset = () => {
        this.setState({ hasError: false, error: null, errorInfo: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: 24, maxWidth: 900, margin: '40px auto' }}>
                    <MessageBar messageBarType={MessageBarType.error} isMultiline>
                        <h3 style={{ margin: '0 0 8px 0', color: '#a80000' }}>Terjadi Kesalahan pada Halaman</h3>
                        <p style={{ margin: 0, fontWeight: 500 }}>
                            {this.state.error?.message || 'Unknown error occurred'}
                        </p>
                    </MessageBar>

                    <Stack horizontal tokens={{ childrenGap: 12 }} style={{ marginTop: 16 }}>
                        <PrimaryButton text="Muat Ulang Halaman" onClick={this.handleReload} />
                        <DefaultButton
                            text={this.state.showDetails ? 'Sembunyikan Detail' : 'Lihat Detail Error'}
                            onClick={() => this.setState({ showDetails: !this.state.showDetails })}
                        />
                        <DefaultButton text="Coba Lagi" onClick={this.handleReset} />
                    </Stack>

                    {this.state.showDetails && (
                        <div
                            style={{
                                marginTop: 16,
                                padding: 16,
                                background: '#f3f4f6',
                                borderRadius: 6,
                                border: '1px solid #d1d5db',
                                fontSize: 12,
                                fontFamily: 'monospace',
                                whiteSpace: 'pre-wrap',
                                overflowX: 'auto',
                            }}
                        >
                            <strong>Stack Trace:</strong>
                            <br />
                            {this.state.error?.stack}
                            {this.state.errorInfo?.componentStack && (
                                <>
                                    <br />
                                    <br />
                                    <strong>Component Stack:</strong>
                                    <br />
                                    {this.state.errorInfo.componentStack}
                                </>
                            )}
                        </div>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;

